<template>
    <div class="container pt-5 pb-4 text-center">
        <h1 style="font-size:2.5rem;">(404) Page NotFound</h1>  
    </div>
</template>

<script>
export default {};
</script>
